var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _polygon, _path11, _path12, _rect, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFC05D;}\n\t.st1{fill:#535D6C;}\n\t.st2{fill:#7B8D9A;}\n\t.st3{fill:#40AA9D;}\n\t.st4{fill:#7CC6B5;}\n\t.st5{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.57,182.64c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C30.27,148.35,64.88,182.64,107.57,182.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.63,145.14c0,0-3.4,10.53-45.72-16.07l-44.47-27.95c-2.74-1.72-3.56-5.34-1.84-8.08l3.96-6.3 c0,0,21.14,13.29,44.22,32.26C131.31,136.67,153.63,145.14,153.63,145.14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.31,84.03c19.21,12.07,36,7.09,36,7.09s-7.79-7.06-13.61-7.32c-6.74-0.31-9.96-1.32-15.07-5.13 c-5.38-4.01-2.34-6.52-6.28-10.03c-3.38-3.01-11.47,0.77-11.47,0.77S87.39,73.03,91.31,84.03z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.11,106.68C77.95,94.52,65.57,86.74,65.57,86.74s5.52-13.36,15.31-17.32 C80.88,69.42,95.55,77.56,94.11,106.68z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.63,145.14c0,0,6.05-7.1,1.32-12.36c-5.96-6.64-12.25-7.22-16.31-16.59c0,0-16.48-4.56-28.85,2.8 C131.31,136.67,153.63,145.14,153.63,145.14z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.31,84.03c19.21,12.07,36,7.09,36,7.09c1.65,1.45,2.96,2.87,4.06,4.26c-0.96,0.97-3.09,2.55-6.3,1.68 c-0.77-0.21-1.55,0.25-1.76,1.01c-0.2,0.76,0.25,1.55,1.01,1.75c1.68,0.45,3.19,0.42,4.52,0.12c1.76-0.4,3.18-1.29,4.19-2.2 c1.14,1.84,1.91,3.63,2.46,5.36c-0.93,0.86-3.76,3.04-7.34,1.8c-0.75-0.26-1.56,0.14-1.82,0.89c-0.26,0.75,0.14,1.56,0.88,1.82 c1.92,0.67,3.67,0.65,5.18,0.31c1.61-0.37,2.93-1.1,3.88-1.78c0.76,3.57,1,6.91,2.36,10.05c0,0-16.48-4.56-28.85,2.8 c-5.42-4.45-10.73-8.59-15.68-12.32C94.59,96.95,93.27,89.56,91.31,84.03z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.32,99.84c-0.76-0.21-1.22-0.99-1.01-1.75c0.2-0.76,0.99-1.22,1.76-1.01c3.21,0.86,5.34-0.71,6.3-1.68 c0.63,0.8,1.19,1.59,1.67,2.37c-1.01,0.91-2.43,1.8-4.19,2.2C127.52,100.26,126,100.29,124.32,99.84z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.21,107.62c-0.75-0.26-1.14-1.07-0.88-1.82c0.26-0.75,1.08-1.14,1.82-0.89c3.58,1.24,6.4-0.94,7.34-1.8 c0.32,1.03,0.58,2.04,0.79,3.03c-0.96,0.68-2.28,1.42-3.88,1.78C130.89,108.27,129.14,108.29,127.21,107.62z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.52,91.49c0-0.04,0-0.08-0.01-0.11C117.52,91.41,117.52,91.45,117.52,91.49L117.52,91.49z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.17,89.14c-0.02-0.09-0.04-0.18-0.06-0.27C117.13,88.97,117.15,89.05,117.17,89.14L117.17,89.14z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.34,89.91L117.34,89.91c0.01,0.08,0.02,0.17,0.04,0.25C117.36,90.08,117.35,90,117.34,89.91z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.83,87.87c-0.02-0.07-0.05-0.13-0.07-0.2C116.78,87.74,116.81,87.81,116.83,87.87L116.83,87.87z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "115.55,99.97 115.55,99.97 115.54,99.97 "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.41,94.56c0,0.02-0.01,0.04-0.01,0.07C117.4,94.6,117.4,94.58,117.41,94.56z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.09,102.05L114.09,102.05c-0.27,0.32-0.55,0.65-0.86,0.95C113.54,102.69,113.82,102.37,114.09,102.05z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.82,
    y: 101.1,
    className: "st5",
    width: 0,
    height: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.11,96.09c-0.01,0.02-0.01,0.04-0.02,0.07C117.1,96.13,117.11,96.11,117.11,96.09z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.54,93.03c0,0.01,0,0.02,0,0.03C117.54,93.05,117.54,93.04,117.54,93.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/Running.9e11337428da6617e37b784e30469505.svg";
export { ForwardRef as ReactComponent };